// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BasicHeader-header-ead6{z-index:1;position:fixed;top:16px;right:16px}`, "",{"version":3,"sources":["webpack://./src/page/BasicHeader/BasicHeader.module.scss"],"names":[],"mappings":"AAAA,yBACE,SAAA,CACA,cAAA,CACA,QAAA,CACA,UAAA","sourcesContent":[".header {\n  z-index: 1;\n  position: fixed;\n  top: 16px;\n  right: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `BasicHeader-header-ead6`
};
module.exports = ___CSS_LOADER_EXPORT___;
